export const createUrlPath = (path: string) => {
  const prefix = '/app'

  return `${prefix}${path.startsWith('/') ? path : `/${path}`}`
}
